import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Paper,
  Grid,
  Card,
  CardContent,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Switch,
  FormControlLabel,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction
} from '@mui/material';
import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  ExpandMore as ExpandMoreIcon,
  Inventory as InventoryIcon,
  Category as CategoryIcon,
  Branding as BrandingIcon,
  Code as CodeIcon,
  Description as DescriptionIcon,
  Settings as SettingsIcon
} from '@mui/icons-material';
import { useCompany } from '../context/CompanyContext';

const StockCard = () => {
  const { stockItems } = useCompany();
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [brands, setBrands] = useState([]);
  const [units, setUnits] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [editingProduct, setEditingProduct] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    subName: '',
    productCode: '',
    brand: '',
    category: '',
    subCategory: '',
    title: '',
    seoUrl: '',
    htmlDescription: '',
    dimensions: {
      length: 0,
      width: 0,
      height: 0,
      weight: 0
    },
    unit: '',
    oemNumbers: [],
    compatibleVehicles: [],
    compatibleDevices: [],
    isActive: true,
    isCombined: false,
    combinedProducts: [],
    stock: 0,
    minStock: 0,
    maxStock: 0,
    purchasePrice: 0,
    salePrice: 0,
    taxRate: 18,
    barcode: '',
    supplierCode: '',
    location: '',
    notes: ''
  });

  useEffect(() => {
    // TODO: Load data from API
    setProducts([
      {
        id: 1,
        name: 'Motor Yağı',
        subName: 'Sentetik 5W-30',
        productCode: 'MY-001',
        brand: 'Bosch',
        category: 'Motor Parçaları',
        subCategory: 'Motor Yağı',
        title: 'Bosch Sentetik Motor Yağı 5W-30 4L',
        seoUrl: 'bosch-sentetik-motor-yagi-5w30-4l',
        htmlDescription: '<p>Yüksek kaliteli sentetik motor yağı</p>',
        dimensions: { length: 20, width: 15, height: 10, weight: 3.5 },
        unit: 'Litre',
        oemNumbers: ['123456789', '987654321'],
        compatibleVehicles: ['BMW X5', 'Mercedes C-Class'],
        compatibleDevices: ['Beyaz Eşya Servisi'],
        isActive: true,
        isCombined: false,
        stock: 150,
        minStock: 10,
        maxStock: 200,
        purchasePrice: 45.50,
        salePrice: 65.00,
        taxRate: 18,
        barcode: '8680001234567',
        supplierCode: 'BOSCH-MY001',
        location: 'A-01-01',
        notes: 'Premium kalite motor yağı'
      }
    ]);

    setCategories([
      { id: 1, name: 'Motor Parçaları', subCategories: ['Motor Yağı', 'Filtreler', 'Sensörler'] },
      { id: 2, name: 'Fren Sistemi', subCategories: ['Fren Balataları', 'Fren Diskleri', 'Fren Hidroliği'] },
      { id: 3, name: 'Elektrik Sistemi', subCategories: ['Aküler', 'Ampuller', 'Sigortalar'] }
    ]);

    setBrands([
      { id: 1, name: 'Bosch' },
      { id: 2, name: 'Continental' },
      { id: 3, name: 'Valeo' },
      { id: 4, name: 'Delphi' }
    ]);

    setUnits([
      { id: 1, name: 'Adet' },
      { id: 2, name: 'Kg' },
      { id: 3, name: 'Litre' },
      { id: 4, name: 'Metre' }
    ]);
  }, []);

  const handleAddProduct = () => {
    setEditingProduct(null);
    setFormData({
      name: '',
      subName: '',
      productCode: '',
      brand: '',
      category: '',
      subCategory: '',
      title: '',
      seoUrl: '',
      htmlDescription: '',
      dimensions: { length: 0, width: 0, height: 0, weight: 0 },
      unit: '',
      oemNumbers: [],
      compatibleVehicles: [],
      compatibleDevices: [],
      isActive: true,
      isCombined: false,
      combinedProducts: [],
      stock: 0,
      minStock: 0,
      maxStock: 0,
      purchasePrice: 0,
      salePrice: 0,
      taxRate: 18,
      barcode: '',
      supplierCode: '',
      location: '',
      notes: ''
    });
    setOpenDialog(true);
  };

  const handleEditProduct = (product) => {
    setEditingProduct(product);
    setFormData(product);
    setOpenDialog(true);
  };

  const handleSave = () => {
    // TODO: Implement save functionality
    console.log('Save product:', formData);
    setOpenDialog(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name.includes('.')) {
      const [parent, child] = name.split('.');
      setFormData(prev => ({
        ...prev,
        [parent]: {
          ...prev[parent],
          [child]: parseFloat(value) || 0
        }
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const addOemNumber = () => {
    const newOem = prompt('OEM numarası girin:');
    if (newOem) {
      setFormData(prev => ({
        ...prev,
        oemNumbers: [...prev.oemNumbers, newOem]
      }));
    }
  };

  const removeOemNumber = (index) => {
    setFormData(prev => ({
      ...prev,
      oemNumbers: prev.oemNumbers.filter((_, i) => i !== index)
    }));
  };

  const addCompatibleVehicle = () => {
    const newVehicle = prompt('Uyumlu araç girin:');
    if (newVehicle) {
      setFormData(prev => ({
        ...prev,
        compatibleVehicles: [...prev.compatibleVehicles, newVehicle]
      }));
    }
  };

  const removeCompatibleVehicle = (index) => {
    setFormData(prev => ({
      ...prev,
      compatibleVehicles: prev.compatibleVehicles.filter((_, i) => i !== index)
    }));
  };

  const addCompatibleDevice = () => {
    const newDevice = prompt('Uyumlu cihaz girin:');
    if (newDevice) {
      setFormData(prev => ({
        ...prev,
        compatibleDevices: [...prev.compatibleDevices, newDevice]
      }));
    }
  };

  const removeCompatibleDevice = (index) => {
    setFormData(prev => ({
      ...prev,
      compatibleDevices: prev.compatibleDevices.filter((_, i) => i !== index)
    }));
  };

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h4" gutterBottom>
          Stok Kartı Yönetimi
        </Typography>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={handleAddProduct}
        >
          Yeni Stok Kartı
        </Button>
      </Box>

      <Grid container spacing={3}>
        {/* Products List */}
        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Stok Kartları
              </Typography>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Ürün Adı</TableCell>
                      <TableCell>Kod</TableCell>
                      <TableCell>Marka</TableCell>
                      <TableCell>Kategori</TableCell>
                      <TableCell>Stok</TableCell>
                      <TableCell>Satış Fiyatı</TableCell>
                      <TableCell>Durum</TableCell>
                      <TableCell>İşlemler</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {products.map((product) => (
                      <TableRow key={product.id}>
                        <TableCell>
                          <Box>
                            <Typography variant="body1">{product.name}</Typography>
                            <Typography variant="caption" color="text.secondary">
                              {product.subName}
                            </Typography>
                          </Box>
                        </TableCell>
                        <TableCell>{product.productCode}</TableCell>
                        <TableCell>{product.brand}</TableCell>
                        <TableCell>{product.category}</TableCell>
                        <TableCell>
                          <Chip
                            label={`${product.stock} ${product.unit}`}
                            color={product.stock < product.minStock ? 'error' : 'success'}
                            size="small"
                          />
                        </TableCell>
                        <TableCell>₺{product.salePrice}</TableCell>
                        <TableCell>
                          <Chip
                            label={product.isActive ? 'Aktif' : 'Pasif'}
                            color={product.isActive ? 'success' : 'default'}
                            size="small"
                          />
                        </TableCell>
                        <TableCell>
                          <IconButton onClick={() => handleEditProduct(product)}>
                            <EditIcon />
                          </IconButton>
                          <IconButton color="error">
                            <DeleteIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Add/Edit Product Dialog */}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="lg" fullWidth>
        <DialogTitle>
          {editingProduct ? 'Stok Kartı Düzenle' : 'Yeni Stok Kartı'}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            {/* Basic Information */}
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom>
                Temel Bilgiler
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Ürün Adı"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                required
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Alt Ad"
                name="subName"
                value={formData.subName}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Ürün Kodu"
                name="productCode"
                value={formData.productCode}
                onChange={handleInputChange}
                required
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel>Marka</InputLabel>
                <Select
                  name="brand"
                  value={formData.brand}
                  label="Marka"
                  onChange={handleInputChange}
                >
                  {brands.map(brand => (
                    <MenuItem key={brand.id} value={brand.name}>{brand.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel>Kategori</InputLabel>
                <Select
                  name="category"
                  value={formData.category}
                  label="Kategori"
                  onChange={handleInputChange}
                >
                  {categories.map(cat => (
                    <MenuItem key={cat.id} value={cat.name}>{cat.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Alt Kategori"
                name="subCategory"
                value={formData.subCategory}
                onChange={handleInputChange}
              />
            </Grid>

            {/* SEO and Description */}
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
                SEO ve Açıklama
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Başlık"
                name="title"
                value={formData.title}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="SEO URL"
                name="seoUrl"
                value={formData.seoUrl}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="HTML Açıklama"
                name="htmlDescription"
                value={formData.htmlDescription}
                onChange={handleInputChange}
                multiline
                rows={4}
              />
            </Grid>

            {/* Stock and Pricing */}
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
                Stok ve Fiyatlandırma
              </Typography>
            </Grid>
            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <InputLabel>Birim</InputLabel>
                <Select
                  name="unit"
                  value={formData.unit}
                  label="Birim"
                  onChange={handleInputChange}
                >
                  {units.map(unit => (
                    <MenuItem key={unit.id} value={unit.name}>{unit.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                label="Stok Miktarı"
                name="stock"
                type="number"
                value={formData.stock}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                label="Minimum Stok"
                name="minStock"
                type="number"
                value={formData.minStock}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                label="Maksimum Stok"
                name="maxStock"
                type="number"
                value={formData.maxStock}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label="Alış Fiyatı"
                name="purchasePrice"
                type="number"
                step="0.01"
                value={formData.purchasePrice}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label="Satış Fiyatı"
                name="salePrice"
                type="number"
                step="0.01"
                value={formData.salePrice}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label="KDV Oranı (%)"
                name="taxRate"
                type="number"
                value={formData.taxRate}
                onChange={handleInputChange}
              />
            </Grid>

            {/* Dimensions */}
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
                Boyutlar
              </Typography>
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                label="Uzunluk (cm)"
                name="dimensions.length"
                type="number"
                step="0.1"
                value={formData.dimensions.length}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                label="Genişlik (cm)"
                name="dimensions.width"
                type="number"
                step="0.1"
                value={formData.dimensions.width}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                label="Yükseklik (cm)"
                name="dimensions.height"
                type="number"
                step="0.1"
                value={formData.dimensions.height}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                label="Ağırlık (kg)"
                name="dimensions.weight"
                type="number"
                step="0.1"
                value={formData.dimensions.weight}
                onChange={handleInputChange}
              />
            </Grid>

            {/* Additional Information */}
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
                Ek Bilgiler
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Barkod"
                name="barcode"
                value={formData.barcode}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Tedarikçi Kodu"
                name="supplierCode"
                value={formData.supplierCode}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Depo Konumu"
                name="location"
                value={formData.location}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Notlar"
                name="notes"
                value={formData.notes}
                onChange={handleInputChange}
                multiline
                rows={2}
              />
            </Grid>

            {/* Lists */}
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
                Uyumluluk ve Referanslar
              </Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography>OEM Numaraları ({formData.oemNumbers.length})</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <List dense>
                    {formData.oemNumbers.map((oem, index) => (
                      <ListItem key={index}>
                        <ListItemText primary={oem} />
                        <ListItemSecondaryAction>
                          <IconButton onClick={() => removeOemNumber(index)}>
                            <DeleteIcon />
                          </IconButton>
                        </ListItemSecondaryAction>
                      </ListItem>
                    ))}
                  </List>
                  <Button onClick={addOemNumber} startIcon={<AddIcon />}>
                    OEM Ekle
                  </Button>
                </AccordionDetails>
              </Accordion>
            </Grid>
            <Grid item xs={12} md={4}>
              <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography>Uyumlu Araçlar ({formData.compatibleVehicles.length})</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <List dense>
                    {formData.compatibleVehicles.map((vehicle, index) => (
                      <ListItem key={index}>
                        <ListItemText primary={vehicle} />
                        <ListItemSecondaryAction>
                          <IconButton onClick={() => removeCompatibleVehicle(index)}>
                            <DeleteIcon />
                          </IconButton>
                        </ListItemSecondaryAction>
                      </ListItem>
                    ))}
                  </List>
                  <Button onClick={addCompatibleVehicle} startIcon={<AddIcon />}>
                    Araç Ekle
                  </Button>
                </AccordionDetails>
              </Accordion>
            </Grid>
            <Grid item xs={12} md={4}>
              <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography>Uyumlu Cihazlar ({formData.compatibleDevices.length})</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <List dense>
                    {formData.compatibleDevices.map((device, index) => (
                      <ListItem key={index}>
                        <ListItemText primary={device} />
                        <ListItemSecondaryAction>
                          <IconButton onClick={() => removeCompatibleDevice(index)}>
                            <DeleteIcon />
                          </IconButton>
                        </ListItemSecondaryAction>
                      </ListItem>
                    ))}
                  </List>
                  <Button onClick={addCompatibleDevice} startIcon={<AddIcon />}>
                    Cihaz Ekle
                  </Button>
                </AccordionDetails>
              </Accordion>
            </Grid>

            {/* Settings */}
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
                Ayarlar
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControlLabel
                control={
                  <Switch
                    checked={formData.isActive}
                    onChange={(e) => setFormData(prev => ({ ...prev, isActive: e.target.checked }))}
                  />
                }
                label="Aktif"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControlLabel
                control={
                  <Switch
                    checked={formData.isCombined}
                    onChange={(e) => setFormData(prev => ({ ...prev, isCombined: e.target.checked }))}
                  />
                }
                label="Kombine Ürün"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>İptal</Button>
          <Button onClick={handleSave} variant="contained">
            {editingProduct ? 'Güncelle' : 'Kaydet'}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default StockCard; 